define([
	"dojo/_base/declare",
	"csi/action/_NewCommentMixin",
	"csi/heading/Controller",
	"csi/xml",
	"dojo/text!csi/widget/CommentDialogAttribute.html",
	"csi/utility/htmlUtility"
], function(declare,_NewCommentMixin,Controller,xml,template, {getTrimmedInnerText}) {

	return declare([Controller, _NewCommentMixin], {
		bRichRefNode: true,
		dialogTemplate: template,

		preProcess: function() {
			// summary: open comment dialog for editing
			var	node = this.getNode();
			var	id = this.heading.m_id;

			this.edit(this.getTitle(), {
				text: node[xml.idGetComment(id)] || "",
				color: node[xml.idGetCommentColor(id)] || ""
			});
		},

		preProcessContinue: function() {
			this.process();
		},

		toWriter: function() {
			// summary: bypass process function and go straight to publishing
			const { m_id } = this.heading;
			const cn = this.m_writer.changeNode(this.m_urlNode);
			const colorId = xml.idGetCommentColor(m_id);
			const commentId = xml.idGetComment(m_id);
			const { color, text } = this.commentValues;

			if (!color) {
				cn.deleteAttribute(colorId);
			} else {
				cn.addAttribute(colorId, xml.ATTR_STRING, color);
			}

			if (!getTrimmedInnerText(text)) {
				cn.deleteAttribute(commentId);
			} else {
				cn.addAttribute(commentId,  xml.ATTR_STRING, text);
			}
		},

		postProcessSuccess: function() {
			// summary: refresh heading
			this.widget.refreshHeadingCell(this.getContext(), this.heading, this.refNode);
		}
	});
});